"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const library_ui_expander_1 = __importDefault(require("@talus-analytics/library.ui.expander"));
const InteractionTarget = styled_components_1.default.div `
  // start a new block context to capture margins
  display: flow-root;
`;
const Dropdown = (_a) => {
    var { renderButton, children, onOpen, onClose, hover = false, floating = true, animDuration = 250, expanderStyle = {}, debugOpen } = _a, props = __rest(_a, ["renderButton", "children", "onOpen", "onClose", "hover", "floating", "animDuration", "expanderStyle", "debugOpen"]);
    const [open, setOpen] = (0, react_1.useState)(undefined);
    const [touchScreen, setTouchScreen] = (0, react_1.useState)(false);
    // Handle touch screens: if a touch event is detected, override the
    // hover prop to change the behavior to respond to tap events as
    // though the dropdown was in click-to-open mode the whole time.
    // detecting touch events like this is a better way to detect
    // what the user wants rather than what the device can do, like
    // in cases where the user is using a touchscreen laptop but
    // might only be using their mouse, in which case we would still
    // want the dropdown to act as a hover dropdown and not a tap dropdown.
    (0, react_1.useEffect)(() => {
        const handleTouch = () => setTouchScreen(true);
        if (typeof window !== 'undefined') {
            window.addEventListener('touchstart', handleTouch);
        }
        return () => {
            if (typeof window !== 'undefined') {
                window.removeEventListener('touchstart', handleTouch);
            }
        };
    }, []);
    // handle onOpen and onClose effects
    (0, react_1.useEffect)(() => {
        open === true && onOpen && onOpen();
        open === false && onClose && onClose();
    }, [open, onClose, onOpen]);
    // detect onBlur, set a no-time timer to close it next tick but cancel
    // the timer if one of the child elements got focus. taken from here:
    // https://reactjs.org/docs/accessibility.html#mouse-and-pointer-events
    // This approach handles closing the expander when the user clicks away
    // but also when the user navigates away using the keyboard.
    let blurTimeout;
    const onBlurHandler = () => {
        blurTimeout = setTimeout(() => {
            setOpen(false);
        });
    };
    const onFocusHandler = () => {
        clearTimeout(blurTimeout);
    };
    // by default, clicking the button opens / closes the expander
    let mouseHandlers = { onClick: () => setOpen(prev => !prev) };
    let hoverHandlers = {};
    // if hover is true, only allow onClick events from the keyboard
    // (detected because the clientX and clientY are zero) and use
    // onMouseEnter and onMouseLeave to open / close the dropdown
    if (hover) {
        mouseHandlers = {
            onClick: e => {
                if (touchScreen)
                    setOpen(prev => !prev);
                if (e.clientX === 0 && e.clientY === 0)
                    setOpen(prev => !prev);
            },
        };
        hoverHandlers = {
            onMouseEnter: () => {
                if (!touchScreen)
                    setOpen(true);
            },
            onMouseLeave: () => setOpen(false),
        };
    }
    // render the renderButton render props function,
    // and clone it with the new props we need
    const buttonWithProps = react_1.default.cloneElement(Object.assign({}, renderButton(open !== null && open !== void 0 ? open : false, animDuration)), Object.assign(Object.assign(Object.assign({}, mouseHandlers), hoverHandlers), { 'aria-expanded': open ? 'true' : 'false', 'aria-haspopup': 'true' }));
    // check if we're being passed the right kind
    // of element in the render prop function
    if (
    // standard react elements will have type as a string
    (typeof buttonWithProps.type === 'string' &&
        buttonWithProps.type !== 'button') ||
        // styled components have type.target
        (typeof buttonWithProps.type === 'object' &&
            buttonWithProps.type.target !== 'button')) {
        const type = (typeof buttonWithProps.type === 'string' && buttonWithProps.type) ||
            (typeof buttonWithProps.type === 'object' &&
                buttonWithProps.type.target);
        throw new Error(`renderButton render prop in dropdown ` +
            `must render a button element for accessibility. ` +
            `Element type found was ${type}.`);
    }
    return (react_1.default.createElement("div", { onFocus: onFocusHandler, onBlur: onBlurHandler },
        buttonWithProps,
        react_1.default.createElement(library_ui_expander_1.default, Object.assign({}, props, { floating: floating, style: expanderStyle }, { open, animDuration }, (debugOpen ? { open: true } : {})),
            react_1.default.createElement(InteractionTarget, Object.assign({}, hoverHandlers, { tabIndex: -1 }), children))));
};
exports.default = Dropdown;
//# sourceMappingURL=Dropdown.js.map